import type { AgentMetricsSnapshot } from "../utils/types";

type StatusBreakdownProps = {
  metrics: AgentMetricsSnapshot | null;
};

const items = [
  { key: "started" as const, label: "active", color: "var(--chart-blue)" },
  { key: "completed" as const, label: "completed", color: "var(--chart-green)" },
  { key: "failed" as const, label: "failed", color: "var(--chart-red)" },
  { key: "fallback" as const, label: "fallback", color: "#f97316" },
];

export const StatusBreakdown = ({ metrics }: StatusBreakdownProps) => {
  const stuckRuns = metrics?.stuckRuns ?? 0;

  return (
    <section className="admin-card">
      <h2 className="admin-card-title">Status</h2>
      <div className="flex flex-wrap items-center gap-x-5 gap-y-2 text-sm text-[var(--admin-muted)]">
        {items.map((item) => (
          <span key={item.key}>
            <span className="admin-status-dot" style={{ background: item.color }} />
            {item.label}: {metrics?.statusCounts[item.key] ?? 0}
          </span>
        ))}
        {stuckRuns > 0 ? (
          <span className="font-medium text-[var(--chart-red)]">
            stuck: {stuckRuns}
          </span>
        ) : null}
      </div>
    </section>
  );
};
